export default __webpack_public_path__ + "static/media/827.595225fb.png";